import React from 'react'
import AppointmentsSummaryChart from './AppointmentsSummaryChart'
import HourChart from './HourChart'
import BoxesMap from './BoxesMap'
import AppointmentEventsChart from './AppointmentEventsChart'
import PostalPlaceFilledChart from './PostalPlaceFilledChart'
import { Card, Flex } from 'antd'

export default function MultipleBoxCharts (appointments, selectedBoxes) {
  const groupedCharts = (charts) => (
    <Card>
      <Flex justify='space-around'>
        {charts.map(Chart => <Chart appointments={appointments.filter(appointment => (appointment.type === 'PatientAppointment' && appointment.state === 'done'))} key={Chart.toString()} />) }
      </Flex>
    </Card>
  )

  return [
    { key: 'appointmentSummary', children: (<AppointmentsSummaryChart appointments={appointments} />) },
    { key: 'appointmentHour', children: (<HourChart appointments={appointments} />) },
    { key: 'boxesMap', children: (<BoxesMap appointments={appointments.filter(appointment => appointment.type === 'PatientAppointment' && appointment.state === 'done')} selectedBoxes={selectedBoxes} />) },
    { key: 'groupedCharts1', children: (groupedCharts([AppointmentEventsChart, PostalPlaceFilledChart])) }
  ]
}
